import React, { useEffect, useState } from "react";
import { InputDate } from "../../../../components/InputDate";
import ResponsiveModalAbsolute from "../../../../components/ResponsiveModalAbsolute";
import { fetchAxiosToken } from "../../../../helpers/fetchAxiosToken";
import { ShowDateToUser } from "../../../../components/ShowDateToUser";
import { tarifaAvanzada } from "./TarifaAvanzada";
import { useAppSelector } from "../../../../hooks/hooks";
import Swal from "sweetalert2";

interface ModalProps {
    tarifaSelected: tarifaAvanzada | null;
    modalVisible: boolean;
    setModalVisible: (visible: boolean) => void;
    getTarifas: () => void;
}

type errorObject = { [key: string]: string };

export const EditarTarifaAvanzada = ({
    modalVisible,
    setModalVisible,
    getTarifas,
    tarifaSelected,
}: ModalProps) => {
    const { tipo_usuario } = useAppSelector((state) => state.usuario_logeado);
    const [loading, setLoading] = useState(false);
    const [input, setInput] = useState<tarifaAvanzada>({
        fecha_inicio: "",
        fecha_final: "",
        precio: "",
    });
    const [errors, setErrors] = useState<tarifaAvanzada>({});
    useEffect(() => {
        if (tarifaSelected) {
            setInput({
                fecha_inicio: tarifaSelected.fecha_inicio,
                fecha_final: tarifaSelected.fecha_final,
                precio: tarifaSelected.precio,
            });
        }
    }, [tarifaSelected]);

    const validateInput = (form: tarifaAvanzada) => {
        let errores: errorObject = {};

        if (!form.fecha_inicio) {
            errores.fecha_inicio = "Debe ingresar una fecha inicial";
        } else if (!form.fecha_final) {
            errores.fecha_final = "Debe ingresar una fecha final";
        } else if (!form.precio || Number(form.precio) < 0) {
            errores.precio = "Debe ingresar un precio válido";
        }

        return errores;
    };

    const handleSubmit = async () => {
        const errors = validateInput(input);
        setErrors(errors);

        if (Object.entries(errors).length === 0) {
            try {
                setLoading(true);

                if (
                    tipo_usuario === 3 ||
                    tipo_usuario === 4 ||
                    tipo_usuario === 6
                ) {
                    await fetchAxiosToken({
                        url: `/servicios_adicionales/put/${tarifaSelected?.id}`,
                        body: {
                            ...input,
                            id_servicios_adicionales:
                                tarifaSelected?.id_servicios_adicionales,
                        },
                        method: "put",
                    });
                }

                if (tipo_usuario === 8) {
                    await fetchAxiosToken({
                        url: `/servicios_adicionales_avanzado_habitaciones/put/${tarifaSelected?.id}`,
                        body: {
                            ...input,
                            id_servicios_adicionales_habitaciones:
                                tarifaSelected?.id_servicios_adicionales_habitaciones,
                        },
                        method: "put",
                    });
                }
                Swal.fire({
                    confirmButtonColor: "#029BFC",
                    iconColor: "#029BFC",
                    title: "Actualizado con éxito",

                    icon: "success",
                    confirmButtonText: "Ok",
                });
                setLoading(false);
                setInput({
                    fecha_final: "",
                    fecha_inicio: "",
                    precio: "",
                });
                getTarifas();
                setModalVisible(false);
                setErrors({});
            } catch (error) {
                setLoading(false);
                console.log(error);
            }
        }
    };

    return (
        <ResponsiveModalAbsolute
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
            onClose={() => {
                setErrors({});
            }}>
            <div className="flex flex-col gap-2 p-3">
                <h1 className="text-base font-medium text-center 2xl:text-lg">
                    Editar configuración de tarifa avanzada
                </h1>
                <div className={`flex flex-col gap-1 mt-4 p-3`}>
                    <label className="text-sm 2xl:text-base">
                        Fecha inicial
                    </label>
                    <InputDate
                        className="p-2 text-sm border-2 2xl:text-base 2xl:p-3"
                        selectedDay={input.fecha_inicio}
                        placeholderText="13/05/2023"
                        onChange={(date) =>
                            setInput({
                                ...input,
                                fecha_inicio: date,
                            })
                        }
                    />
                    <label className="text-sm 2xl:text-base">Fecha final</label>
                    <InputDate
                        className="p-2 text-sm border-2 2xl:text-base 2xl:p-3"
                        selectedDay={input.fecha_final}
                        placeholderText="13/08/2023"
                        onChange={(date) =>
                            setInput({
                                ...input,
                                fecha_final: date,
                            })
                        }
                    />
                    <label className="text-sm 2xl:text-base">Precio</label>
                    <input
                        value={input.precio}
                        onChange={(e) =>
                            setInput({
                                ...input,
                                precio: e.target.value,
                            })
                        }
                        type={"text"}
                        className="p-2 text-sm border-2 rounded-lg 2xl:text-base 2xl:p-3"
                        placeholder="250.00"
                    />
                    <button
                        disabled={loading}
                        onClick={() => handleSubmit()}
                        className="max-w-xs p-3 mx-auto mt-4 text-sm border-2 rounded-lg hover:bg-blue-blueFrom hover:text-white disabled:bg-gray-400 disabled:translate-y-0 active:translate-y-1 2xl:text-base">
                        Guardar configuración
                    </button>
                </div>
            </div>
        </ResponsiveModalAbsolute>
    );
};
